import Link from 'next/link';
import { Button } from '@components/common/button';
import { menus } from '@components/common/footer/constants';
import { companyInfo } from '@libraries/common/companyInfo';
import SteadioFullLogo from '@assets/svgs/logo/SteadioFullLogo.svg';

const {
  startCreator,
  communityPolicy,
  contactUs,
  helpCenter,
  instagram,
  kakaotalk,
  operatingHours,
  privacyPolicy,
  serviceIntroduction,
  termsOfUse,
  twitter,
  notice,
  creatorGuide,
} = menus;

const {
  address,
  ceo,
  companyName,
  coporateRegistrationNumber,
  copyright,
  mainPhoneNumber,
  onlineMarketingRegistrationNumber,
} = companyInfo;

export default function DesktopMainFooter() {
  return (
    <div className="pt-[40px] pb-[45px]">
      <div className="pb-[28px] border-b border_primary flex justify-between">
        <SteadioFullLogo className="w-[128px] h-[18px] content_secondary" />
        <div className="flex gap-x-[52px]">
          <DesktopMenu>
            <DesktopMenuTitle title="스테디오" />
            <DesktopMenuLink
              href={startCreator.link}
              menuName={startCreator.name}
            />
            <DesktopMenuLink
              href={serviceIntroduction.link}
              menuName={serviceIntroduction.name}
            />
            <DesktopMenuLink href={notice.link} menuName={notice.name} />
          </DesktopMenu>
          <DesktopMenu>
            <DesktopMenuTitle title="이용안내" />
            <DesktopMenuLink
              href={helpCenter.link}
              menuName={helpCenter.name}
            />
            <DesktopMenuLink
              href={creatorGuide.link}
              menuName={creatorGuide.name}
            />
          </DesktopMenu>
          <DesktopMenu>
            <DesktopMenuTitle title="정책" />
            <DesktopMenuLink
              href={termsOfUse.link}
              menuName={termsOfUse.name}
            />
            <DesktopMenuLink
              href={privacyPolicy.link}
              menuName={privacyPolicy.name}
            />
            <DesktopMenuLink
              href={communityPolicy.link}
              menuName={communityPolicy.name}
            />
          </DesktopMenu>
          <DesktopMenu>
            <DesktopMenuTitle title="고객지원" />
            <p className="mt-[8px] font_label_regular_lg">
              {operatingHours.name}
            </p>
            <Link href={contactUs.link}>
              <a target="_blank" className="mt-[12px]">
                <Button shape="rect" size="medium" color="outline" fullWidth>
                  {contactUs.name}
                </Button>
              </a>
            </Link>
          </DesktopMenu>
        </div>
      </div>
      <div className="mt-[20px] content_quaternary">
        <p>
          <CompanyInfo title={companyName.title} value={companyName.value} />
          <CompanyInfo title={address.title} value={address.value} />
          <CompanyInfo title={ceo.title} value={ceo.value} />
        </p>
        <p>
          <CompanyInfo
            title={coporateRegistrationNumber.title}
            value={coporateRegistrationNumber.value}
          />
          <CompanyInfo
            title={onlineMarketingRegistrationNumber.title}
            value={onlineMarketingRegistrationNumber.value}
          />
          <CompanyInfo
            title={mainPhoneNumber.title}
            value={mainPhoneNumber.value}
          />
        </p>
      </div>
      <div className="mt-[20px] flex justify-between items-center">
        <p className="font_label_regular_lg content_tertiary">
          {copyright.value}
        </p>
        <div className="flex">
          <SocialLink href={kakaotalk.link} icon={kakaotalk.icon} />
          <SocialLink href={twitter.link} icon={twitter.icon} />
          <SocialLink href={instagram.link} icon={instagram.icon} />
        </div>
      </div>
    </div>
  );
}

type DesktopMenuProps = {
  children: React.ReactNode;
};

const DesktopMenu = ({ children }: DesktopMenuProps) => (
  <div className="flex flex-col content_secondary">{children}</div>
);

type DesktopMenuTitleProps = {
  title: string;
};

const DesktopMenuTitle = ({ title }: DesktopMenuTitleProps) => (
  <h5 className="font_label_bold_xl mb-[8px]">{title}</h5>
);

type DesktopMenuLinkProps = {
  href: string;
  menuName: string;
};

const DesktopMenuLink = ({ href, menuName }: DesktopMenuLinkProps) => (
  <Link href={href}>
    <a target="_blank" className="mt-[8px] font_label_regular_lg">
      {menuName}
    </a>
  </Link>
);

type CompanyInfoProps = {
  title: string;
  value: string;
};

const CompanyInfo = ({ title, value }: CompanyInfoProps) => (
  <>
    <span className="font_label_bold_md ml-[12px] first:m-0">{title}</span>
    <span className="ml-[8px] font_label_regular_md">{value}</span>
  </>
);

type SocialLinkProps = {
  href: string;
  icon: any;
};

const SocialLink = ({ href, icon }: SocialLinkProps) => (
  <Link href={href}>
    <a target="_blank" className="ml-[20px] first:m-0">
      {icon({
        className: 'w-[24px] h-[24px] content_secondary',
      })}
    </a>
  </Link>
);
